import { get, post } from '@/lib/http';

export default {
  async getDetail(code) {
    const res = await get(
      `/api/v3/server_resource/book/package/download/resource/${code}`
    ).catch((error) => {
      throw error;
    });
    return res;
  },
  // 发送到邮箱
  // to	T文本	是	 发送邮件收件人邮箱地址
  async sendMail(code, to) {
    const res = await post(
      `/api/v3/server_resource/book/package/download/resource/mail/${to}/${code}`
    ).catch((error) => {
      throw error;
    });
    return res;
  },
  async sendMailWithHref(params) {
    const res = await post(
      `/api/v3/server_resource/book/package/download/resource/mail/href`,
      params
    ).catch((error) => {
      throw error;
    });
    return res;
  },
};
